import React from 'react';
import { Switch } from 'formik-material-ui';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from "@material-ui/core/styles";
import { Field } from 'formik';

const useStyles = makeStyles(theme => ({

  switch:{
    width: "100%"
  }

}))

export const SwitchField = (props: any) => {
  const classes = useStyles();
  return (
    <FormControl component="div" className={classes.switch}>
      <FormLabel component="legend">{props.label}</FormLabel>
      <Typography component="div" color="textPrimary" >
        <Grid component="label" container alignItems="center" spacing={1}  >
          <Grid item>Non</Grid>
          <Grid item>
            <Field {...props} component={Switch} type="checkbox" className="" />
          </Grid>
          <Grid item>Oui</Grid>
        </Grid>
      </Typography>
    </FormControl>
  );
};

export default SwitchField;
